var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({'background-image': 'url('+_vm.src+')', 'width': _vm.width, 'height': _vm.height})})
}
var staticRenderFns = []

export { render, staticRenderFns }